// Shared constants for ProjectCalculator components

export const STRATEGY_PARTNERS = ['Ken', 'Sean', 'Tim', 'Trav', 'Chase'];

export const DEFAULT_TACTICAL_SPECIALISTS = [
  'Creative Pipeline',
  'Design',
  'Content Creation',
  'Video Editing',
  'Paid Ads',
  'SEO',
  'Web Development',
  'Social Media',
  'Email Marketing',
  'Analytics',
  'Strategy Consulting'
];

export const KICKER_TIERS = [
  { value: 'none', label: 'No Performance Bonus', percentage: 0, description: 'Below 5.0X ROAS' },
  { value: 'tier1', label: '5% Bonus', percentage: 0.05, description: '5.0-5.9X ROAS' },
  { value: 'tier2', label: '7.5% Bonus', percentage: 0.075, description: '6.0-6.9X ROAS' },
  { value: 'tier3', label: '10% Bonus', percentage: 0.10, description: '7.0X+ ROAS' },
];

// Default values for new projects
export const DEFAULT_VALUES = {
  revenue: 0,
  profitMargin: 50,
  operationsOverheadPercentage: 4,
  operationsCompensationPerOwner: 2500,
  defaultOperationsOwners: ['Ken'],
  defaultTacticalSpecialists: [
    {
      id: 'default-paid-ads',
      name: 'Paid Ads',
      amount: 2000,
      handlesKickers: true,
      assignedOwner: 'Chase'
    },
    {
      id: 'default-design',
      name: 'Design',
      amount: 1200,
      handlesKickers: true,
      assignedOwner: undefined
    }
  ],
  defaultPerformanceKickers: []
};
